var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

import { FiArrowRight } from 'react-icons/fi';
import styled from 'styled-components';
var ActiveIndicator = styled(FiArrowRight)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  left: 1rem;\n  color: #54a074;\n"])));
export default ActiveIndicator;